const config = {
  name: "park-city",
  features: {
    accessCodes: false,
    moreInformation: true,
    hasParkingInstructions: true,
    hasPromoCodeWarning: false,
    displayPromoTotalUses: true, // Display "Redemptions left" on promo code card
    mandatoryFields: true,
    userPhoneNumber: true,
    showAdaSupport: true,
    userName: true,
    userPostalCode: true
  },
  parkingSession: {
    // The same day, just before 8am
    cancelDaysBefore: 0,
    cancelTime: "08:00",
    cancelTimeOptions: [],
    // Start time offset 6am
    startOffsetHrs: 6,
    // Start date offset from today (0 = today)
    startOffsetDate: 0,
    // End date offset from start time
    endOffsetDate: 365
  }
}
export default config
